import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { logger as E } from "../../shared-lib/index.js";
export var PropertiesBase = /*#__PURE__*/function () {
  function PropertiesBase(t) {
    _classCallCheck(this, PropertiesBase);
    this.properties = t, this.properties = t || {};
  }
  _createClass(PropertiesBase, [{
    key: "To",
    value: function To(t, r, e) {
      var o = this.properties[t];
      return null == o ? (this.No(t), null) : r(o) ? o.value : (this.Oo(e), null);
    }
  }, {
    key: "getStringProperty",
    value: function getStringProperty(t) {
      return this.To(t, this.Fo, "string");
    }
  }, {
    key: "getNumberProperty",
    value: function getNumberProperty(t) {
      return this.To(t, this.Go, "number");
    }
  }, {
    key: "getBooleanProperty",
    value: function getBooleanProperty(t) {
      return this.To(t, this.Ho, "boolean");
    }
  }, {
    key: "getImageProperty",
    value: function getImageProperty(t) {
      return this.To(t, this.Ko, "image");
    }
  }, {
    key: "getJsonProperty",
    value: function getJsonProperty(t) {
      return this.To(t, this.Lo, "jsonobject");
    }
  }, {
    key: "getTimestampProperty",
    value: function getTimestampProperty(t) {
      return this.To(t, this.Qo, "datetime");
    }
  }, {
    key: "Oo",
    value: function Oo(t) {
      E.info("Property is not of type ".concat(t, "."));
    }
  }, {
    key: "No",
    value: function No(t) {
      E.info("".concat(t, " not found in properties."));
    }
  }, {
    key: "Fo",
    value: function Fo(t) {
      return "string" === t.type && "string" == typeof t.value;
    }
  }, {
    key: "Go",
    value: function Go(t) {
      return "number" === t.type && "number" == typeof t.value;
    }
  }, {
    key: "Ho",
    value: function Ho(t) {
      return "boolean" === t.type && "boolean" == typeof t.value;
    }
  }, {
    key: "Ko",
    value: function Ko(t) {
      return "image" === t.type && "string" == typeof t.value;
    }
  }, {
    key: "Lo",
    value: function Lo(t) {
      return "jsonobject" === t.type && "object" == typeof t.value && t.value.constructor == Object;
    }
  }, {
    key: "Qo",
    value: function Qo(t) {
      return "datetime" === t.type && "number" == typeof t.value;
    }
  }]);
  return PropertiesBase;
}();